import React, { useState, useEffect } from 'react';
import placesServices from '../../services/placesServices';
import Card from "../../components/card/Card";
import filterLogo from '../../assets/images/filter.png';
import NavBar from '../../components/nav/NavBar';
import Footer from '../../components/footer/Footer';
import Search from '../../components/search/Search';
import { Link } from 'react-router-dom';
import ReactPaginate from 'react-paginate';
import Loading from '../../components/loading/Loading'; // Import loading component

export default function Places() {
    const [data, setData] = useState([]);
    const [currentPage, setCurrentPage] = useState(0);
    const [filteredData, setFilteredData] = useState([]);
    const [searchResultFound, setSearchResultFound] = useState(true);
    const [loading, setLoading] = useState(false); // Added loading state

    const itemsPerPage = 12;

    useEffect(() => {
        // Set loading to true before fetching data
        setLoading(true);
        placesServices.getAll().then((places) => {
            setData(places);
            setFilteredData(places);
            // Set loading to false after data is fetched
            setTimeout(() => {
                setLoading(false);
            }, 1000); // Hide loading after 1 second
        }).catch((error) => {
            console.error('Error fetching places:', error);
            // Set loading to false in case of error
            setLoading(false);
        });
    }, []);


    useEffect(() => {
        const offset = currentPage * itemsPerPage;
        const currentPageData = filteredData.slice(offset, offset + itemsPerPage);
        setCurrentPage(0); // Reset current page to 0 when the filtered data changes
    }, [filteredData]);

    const handlePageChange = ({ selected }) => {
        setCurrentPage(selected);
    };

    const handleSearch = (searchTerm) => {
        const filtered = data.filter(item =>
            item.name.toLowerCase().includes(searchTerm.toLowerCase())
            // || item.city.toLowerCase().includes(searchTerm.toLowerCase()) ||
            // item.description.toLowerCase().includes(searchTerm.toLowerCase())
        );
        setFilteredData(filtered);
        setSearchResultFound(filtered.length > 0); // Update search result status
    };

    const offset = currentPage * itemsPerPage;
    const currentPageData = filteredData.slice(offset, offset + itemsPerPage);

    return (
        <div>
            <div className='search-and-places-image-container'>
                <div className='header-places-container'>
                    <div className="background"></div>
                    <div className='places-content'>
                        <NavBar />
                        <div className='search-and-places-text-container'>
                            <h1 className='places-header'>Places</h1>
                            <Search onSearch={handleSearch} />
                        </div>
                    </div>
                </div>
            </div>
            <div className='outer-container'>
                <div className='inner-container'>
                    {/* <div className='filter-by-category'>
                        <img src={filterLogo} alt='filter-logo' />
                        <p>Filter by Category</p>
                    </div> */}

                    {loading && <div className='overlay'> <Loading /> </div>} {/* Show loading component when loading is true */}

                    <div className="places-container">
                        {!searchResultFound && <p className='not-found'>Not Found</p>}
                        {currentPageData.map((item) => (
                            <Link className='custom-link' key={item.id} to={`/${item.id}/${item.name.replace(/\s+/g, '')}`}>
                                <Card name={item.name} images={item.images} city={item.city} description={item.description} />
                            </Link>
                        ))}
                    </div>


                    <ReactPaginate
                        previousLabel={'<'}
                        nextLabel={'>'}
                        breakLabel={'...'}
                        pageCount={Math.ceil(filteredData.length / itemsPerPage)}
                        marginPagesDisplayed={2}
                        pageRangeDisplayed={5}
                        onPageChange={handlePageChange}
                        containerClassName={'pagination-container'}
                        // activeClassName={'active'}
                        previousLinkClassName={'pagination-item'}
                        nextLinkClassName={'pagination-item'}
                        pageLinkClassName={'pagination-item'}
                    />
                </div>
            </div>
            <Footer />
        </div>
    )
}
